var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-autocomplete",
    _vm._b(
      {
        ref: "vuecomp",
        staticClass: "pt-0",
        attrs: {
          items: _vm.items,
          "menu-props": { closeOnClick: true },
          dense: _vm.dense,
          outlined: _vm.outlined,
          "hide-selected": "",
          "search-input": _vm.search,
          value: _vm.value,
          multiple: _vm.multiple,
          "item-value": _vm.idField,
          "item-text": _vm.nameField,
          loading: _vm.isLoading,
          filter: _vm.filter
        },
        on: {
          "update:searchInput": function($event) {
            _vm.search = $event
          },
          "update:search-input": function($event) {
            _vm.search = $event
          },
          input: _vm.handleInputChange
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item",
              fn: function({ item }) {
                return [
                  _vm._t(
                    "item",
                    function() {
                      return [
                        _vm._v(
                          "\n      " + _vm._s(item[_vm.nameField]) + "\n    "
                        )
                      ]
                    },
                    { item: item }
                  )
                ]
              }
            },
            {
              key: "selection",
              fn: function({ attrs, selected, item }) {
                return [
                  _vm._t(
                    "selection",
                    function() {
                      return [
                        _c(
                          "v-chip",
                          {
                            attrs: {
                              small: "",
                              value: selected,
                              close: _vm.clearable
                            },
                            on: {
                              "click:close": function($event) {
                                return _vm.handleInputRemove(item)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  item[_vm.shortnameField] ||
                                    item[_vm.nameField]
                                ) +
                                "\n      "
                            )
                          ]
                        )
                      ]
                    },
                    { attrs: attrs, selected: selected, item: item }
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      },
      "v-autocomplete",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }